import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

export const amcInstanceCreationRequestsQueryKey = ["amcInstanceCreationRequests"];

/** The org's most recent AMC instance creation request, or `null` when it has never made one. */
export function useAMCInstanceCreationRequest() {
  return useQuery({
    queryKey: amcInstanceCreationRequestsQueryKey,
    queryFn: async () => await apiClient.getAMCInstanceCreationRequests(),
    // The API orders requests newest first.
    select: (data) => data.results[0] ?? null,
  });
}
